import React from 'react';
import './QuranReadingCourse.css';

const QuranReadingCourse = () => {
    return (
        <div className="course-container">
            <div className="content-section">
                <h2>Quran Reading Course</h2>
                <p>The Quran Reading Course is designed for beginners and those who are unfamiliar with the Arabic language...</p>

                <h3>Course Objectives:</h3>
                <ul>
                    <li><strong>Arabic Alphabets:</strong> Learn to recognize and pronounce the Arabic letters, including their different forms and sounds.</li>
                    <li><strong>Pronunciation and Phonetics:</strong> Understand the rules of Arabic pronunciation...</li>
                    <li><strong>Basic Reading Skills:</strong> Develop the ability to read simple words...</li>
                </ul>

                <h3>Course Structure:</h3>
                <ul>
                    <li><strong>Phase 1 – Introduction to Arabic Alphabets:</strong> Students will begin by learning to recognize...</li>
                    <li><strong>Phase 2 – Combining Letters:</strong> Focus on connecting letters to form simple words...</li>
                    <li><strong>Phase 3 – Basic Quranic Words:</strong> Introduce students to simple Quranic words...</li>
                    <li><strong>Phase 4 – Complete Quranic Recitation:</strong> Progress towards reading full verses...</li>
                </ul>

                <h3>Key Features of the Course:</h3>
                <ul>
                    <li>Step-by-step learning approach...</li>
                    <li>Personalized lessons tailored to each student’s learning pace...</li>
                    <li>Qualified tutors with expertise in teaching Quranic reading and Tajweed...</li>
                </ul>

                <h3>Who Should Join?</h3>
                <ul>
                    <li>Beginners who want to learn how to read the Quran...</li>
                    <li>Individuals who are unfamiliar with the Arabic language...</li>
                </ul>

                <h3>Learning Outcomes:</h3>
                <ul>
                    <li>Ability to read the Quran accurately with correct pronunciation...</li>
                    <li>Strong understanding of the Arabic alphabets and their sounds...</li>
                </ul>

                <h3>Instructor Support:</h3>
                <p>Throughout the course, students will receive personalized support...</p>
            </div>

            <div className="image-section">
                <img src="./images/card17.jpeg" alt="Quran Reading Course" />
            </div>
        </div>
    );
};

export default QuranReadingCourse;
